import Vue from "vue";
import VueRouter from "vue-router";
import i18n from "../i18n";
import { Role } from "./role";
import authService from "@/services/planning/AuthService";

Vue.use(VueRouter);

const routes = [
  {
    path: "/:lang",
    component: {
      render(c) {
        return c("router-view");
      },
    },
    children: [
      {
        path: "/",
        name: "LogIn",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/LogIn.vue"),
      },
      {
        path: "forgot-password",
        name: "ForgotPassword",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/ForgotPassword.vue"),
      },
      {
        path: "reset-password",
        name: "ResetPassword",
        component: () =>
          import(/* webpackChunkName: "about" */ "@/views/ResetPassword.vue"),
      },
      {
        path: "calendar",
        name: "Home",
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
          import(
            /* webpackChunkName: "about" */ "@/views/planning/Calendar.vue"
          ),
        meta: {
          // TODO: take data from the enum instead of the file Role.
          authorize: [
            Role.Admin,
            Role.Trainer,
            Role.ExternalTrainer,
            Role.Commercial,
            Role.Apprenti,
            Role.NotFound,
            Role.RH,
            Role.IT,
            Role.Compta,
          ],
        },
      },
      //ADMIN
      //SALLES
      {
        path: "imports",
        name: "ImportsList",
        component: () =>
          import(/* webpackChunkName: "about" */ "@/views/ViewImportsList.vue"),
        meta: { authorize: [Role.Admin, Role.Commercial] },
      },
      {
        path: "imports/:id",
        name: "ImportDetails",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "@/views/ViewImportDetails.vue"
          ),
        meta: { authorize: [Role.Admin, Role.Commercial] },
      },
      {
        path: "employes",
        name: "CrudViewUsers",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "@/views/planning/ViewUsers.vue"
          ),
        meta: { authorize: [Role.Admin, Role.Commercial] },
      },
      {
        path: "formations",
        name: "CrudViewCourses",
        component: () =>
          import(
            /* webpackChunkName: "home" */ "@/views/planning/ViewCourses.vue"
          ),
        meta: {
          authorize: [Role.Admin, Role.Commercial],
        },
      },
      {
        path: "lieux",
        name: "CrudViewLocations",
        component: () =>
          import(
            /* webpackChunkName: "home" */ "@/views/planning/ViewLocations.vue"
          ),
        meta: { authorize: [Role.Admin, Role.Commercial] },
      },
      {
        path: "eventsparent",
        name: "CrudViewEventsParent",
        component: () =>
          import(
            /* webpackChunkName: "home" */ "@/views/planning/ViewEventsParent.vue"
          ),
        meta: {
          authorize: [Role.Admin, Role.Commercial],
        },
      },
      {
        path: "eventsparent/:id",
        name: "CrudViewEventsParentDetail",
        component: () =>
          import(
            /* webpackChunkName: "home" */ "@/views/planning/ViewEventParentDetails.vue"
          ),
        meta: { authorize: [Role.Admin, Role.Commercial] },
      },
      {
        path: "memento",
        name: "MementoRecord",
        component: () =>
          import(
            /* webpackChunkName: "home" */ "@/views/planning/ViewMementoRecord"
          ),
        meta: { authorize: [Role.Admin, Role.Commercial] },
      },
      {
        path: "memento-details/:id",
        name: "MementoDetails",
        component: () =>
          import(
            /* webpackChunkName: "home" */ "@/views/planning/ViewMementoDetails.vue"
          ),
        meta: { authorize: [Role.Admin, Role.Commercial] },
      },

      {
        path: "email",
        name: "EmailRecord",
        component: () =>
          import(
            /* webpackChunkName: "home" */ "@/views/planning/ViewEmailRecord.vue"
          ),
        meta: { authorize: [Role.Admin, Role.Commercial] },
      },
      {
        path: "profile",
        name: "Profile",
        component: () =>
          import(/* webpackChunkName: "home" */ "@/views/UserProfile.vue"),
        meta: {
          authorize: [
            Role.Admin,
            Role.Trainer,
            Role.ExternalTrainer,
            Role.Commercial,
            Role.Apprenti,
            Role.NotFound,
            Role.RH,
            Role.IT,
            Role.Compta,
          ],
        },
      },
      {
        path: "faq",
        name: "FAQ",
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
          import(
            /* webpackChunkName: "about" */ "@/views/planning/WikiView.vue"
          ),
        meta: {
          // TODO: take data from the enum instead of the file Role.
          authorize: [
            Role.Admin,
            Role.Trainer,
            Role.ExternalTrainer,
            Role.Commercial,
            Role.Apprenti,
            Role.NotFound,
            Role.RH,
            Role.IT,
            Role.Compta,
          ],
        },
      },
      //SALLES
      //ADMIN
      {
        path: "admin/centers",
        name: "CrudViewCenters",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "@/views/salles/admin/crud/CentersCrudView.vue"
          ),
        meta: { authorize: [Role.Admin, Role.Commercial] },
      },
      {
        path: "admin/rooms",
        name: "CrudRooms",
        component: () => import("@/views/salles/admin/crud/RoomsCrudView.vue"),
        meta: { authorize: [Role.Admin, Role.Commercial] },
      },
      {
        path: "admin/equipments",
        name: "CrudEquipments",
        component: () =>
          import("@/views/salles/admin/crud/EquipmentsCrudView.vue"),
        meta: { authorize: [Role.Admin, Role.Commercial] },
      },
      {
        path: "admin/centers/:centerId/rooms",
        name: "admin-center-rooms",
        component: () => import("@/views/salles/admin/crud/RoomsCrudView.vue"),
        meta: { authorize: [Role.Admin, Role.Commercial] },
      },
      {
        path: "admin/centers/:centerId/equipments",
        name: "admin-center-equipments",
        component: () =>
          import("@/views/salles/admin/crud/EquipmentsCrudView.vue"),
        meta: { authorize: [Role.Admin, Role.Commercial] },
      },
      {
        path: "admin/centers/:centerId",
        name: "admin-center-details",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "@/views/salles/admin/details/CenterDetailsView.vue"
          ),
        meta: { authorize: [Role.Admin, Role.Commercial] },
      },
      {
        path: "admin/centers/:centerId/rooms/:roomId",
        name: "admin-details-room",
        component: () =>
          import("@/views/salles/admin/details/RoomDetailsView.vue"),
        meta: { authorize: [Role.Admin, Role.Commercial] },
      },
      {
        path: "admin/",
      },
      {
        path: "admin/desks",
        name: "CrudDesk",
        component: () => import("@/views/salles/admin/crud/DesksCrudView.vue"),
        meta: { authorize: [Role.Admin, Role.Commercial] },
      },
      {
        path: "admin/centers/:centerId/rooms/:roomId/desks",
        name: "admin-room-desks",
        component: () => import("@/views/salles/admin/crud/DesksCrudView.vue"),
        meta: { authorize: [Role.Admin, Role.Commercial] },
      },
      {
        path: "admin/categories",
        name: "CategoriesCrudView",
        component: () =>
          import("@/views/salles/admin/crud/CategoriesCrudView.vue"),
        meta: { authorize: [Role.Admin, Role.Commercial] },
      },
      {
        path: "admin/centers/:centerId/rooms/:roomId/desks/:deskId/deskSlots",
        name: "admin-room-desk-slots",
        component: () =>
          import("@/views/salles/admin/crud/DeskSlotsCrudView.vue"),
        meta: { authorize: [Role.Admin, Role.Commercial] },
      },
      {
        path: "admin/booking-history",
        name: "BookingHistory",
        component: () =>
          import(
            /* webpackChunkName: "home" */ "@/views/salles/admin/crud/BookingHistoryCrudView"
          ),
        meta: { authorize: [Role.Admin, Role.Commercial] },
      },
      {
        path: "admin/BookingHistoryDetails/:id",
        name: "admin-booking-details-history",
        component: () =>
          import("@/views/salles/admin/details/BookingHistoryDetailsView"),
        meta: { authorize: [Role.Admin, Role.Commercial] },
      },
      {
        path: "admin",
      },
      //PUBLIC
      {
        path: "centers",
        name: "ViewCenters",
        component: () => import("@/views/salles/ViewCenters.vue"),
        meta: {
          // TODO: take data from the enum instead of the file Role.
          authorize: [
            Role.Admin,
            Role.Trainer,
            Role.ExternalTrainer,
            Role.Commercial,
            Role.Apprenti,
            Role.NotFound,
            Role.RH,
            Role.IT,
            Role.Compta,
          ],
        },
      },
      {
        path: "centers/:centerGroupId",
        name: "center-details",
        component: () => import("@/views/salles/ViewCenterDetails.vue"),
        meta: {
          authorize: [
            Role.Admin,
            Role.Trainer,
            Role.ExternalTrainer,
            Role.Commercial,
            Role.Apprenti,
            Role.NotFound,
            Role.RH,
            Role.IT,
            Role.Compta,
          ],
        },
      },
      {
        path: "center/:centerId/rooms/:roomId",
        name: "room-details-with-desk-slot",
        component: () => import("@/views/salles/ViewRoomDetails.vue"),
        meta: {
          authorize: [
            Role.Admin,
            Role.Trainer,
            Role.ExternalTrainer,
            Role.Commercial,
            Role.Apprenti,
            Role.NotFound,
            Role.RH,
            Role.IT,
            Role.Compta,
          ],
        },
      },
      {
        path: "centers/:id/rooms",
        name: "ViewCenterRooms",
        component: () => import("@/views/salles/ViewCenterRooms.vue"),
        meta: {
          authorize: [
            Role.Admin,
            Role.Trainer,
            Role.ExternalTrainer,
            Role.Commercial,
            Role.Apprenti,
            Role.NotFound,
            Role.RH,
            Role.IT,
            Role.Compta,
          ],
        },
      },
      {
        path: "centers/:id/equipments",
        name: "ViewCenterEquipments",
        component: () => import("@/views/salles/ViewCenterEquipments.vue"),
        meta: {
          authorize: [
            Role.Admin,
            Role.Trainer,
            Role.ExternalTrainer,
            Role.Commercial,
            Role.Apprenti,
            Role.NotFound,
            Role.RH,
            Role.IT,
            Role.Compta,
          ],
        },
      },
      {
        path: "centers/:id/stats",
        name: "ViewBookingCenter",
        component: () => import("@/views/salles/ViewCenterStats.vue"),
        meta: {
          authorize: [
            Role.Admin,
            Role.Trainer,
            Role.ExternalTrainer,
            Role.Commercial,
            Role.Apprenti,
            Role.NotFound,
            Role.RH,
            Role.IT,
            Role.Compta,
          ],
        },
      },
      {
        path: "mybookings",
        name: "MyBookings",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "@/views/salles/MyBookingsView.vue"
          ),
        meta: {
          authorize: [
            Role.Admin,
            Role.Trainer,
            Role.ExternalTrainer,
            Role.Commercial,
            Role.Apprenti,
            Role.NotFound,
            Role.RH,
            Role.IT,
            Role.Compta,
          ],
        },
      },
    ],
  },
  {
    path: "**",
    redirect: `/${i18n.locale}/calendar`,
  },
];

const router = new VueRouter({
  routes,
  //mode: "history",
});

router.beforeEach((to, from, next) => {
  const { authorize } = to.meta; // TO REVIEW
  let language = to.params.lang;

  if (authorize) {
    if (!authService.isAuth())
      return next({
        path: `/${i18n.locale}/`,
        //query: { returnUrl: to.path },
      });
    if (authorize.length && !authService.userHasSomeRoles(authorize))
      return next({ path: `/${i18n.locale}/${to.path}` });
  }

  if (!language) {
    language = "fr";
  }

  //set the current language for i18n
  i18n.locale = language;

  next();
});
export default router;
